import React, { Component } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';
import { api } from '../../api/api';
import { Alert, Pergunta, AlertErro } from '../../../util/Alertas';

class ModalEditarAllStatusPedido extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.Open = (idsSelecionados, statusPedido) => this.setState({ idsSelecionados, statusPedido, show: true })
    }

    initialState = {
        show: false,
        idsSelecionados: [],
        statusPedido: [],
        novoStatus: 0,
        showMotivo: false,
        motivo: ''
    }

    handleStatusChange = (e) => {
        this.setState({ ...this.state, novoStatus: e.target.value, showMotivo: e.target.value == 5 });
    };

    onHide = () => {
        this.setState(this.initialState);
    }

    handleEditarStatus = async () => {
        const { novoStatus, idsSelecionados, statusPedido, motivo } = this.state;
        if (novoStatus) {
            const data = new FormData();
            const obj = JSON.stringify({
                Ids: idsSelecionados,
                StatusPedidoId: novoStatus,
                Motivo: motivo
            });
            data.append("obj", obj);
            try {
                if (await (Pergunta(`Deseja realmente atualizar o status de ${idsSelecionados.length} pedidos, para ${statusPedido.filter(x => x.status_pedido_id == novoStatus)[0]?.nome}`))) {
                    api.post('/api/pedidos/AtualizarAllStatusPedido', data, res => {
                        Alert('Status dos pedidos atualizados com sucesso!');
                        if (this.props.onReload) {
                            this.props.onReload();
                        }
                        if (this.props.setLinhasSelecionadas) {
                            this.props.setLinhasSelecionadas([]);
                        }
                    }, erro => AlertErro(erro, 'Erro ao alterar o status dos pedidos.'));
                    this.onHide();
                }
            } catch (error) {
                AlertErro(error, 'Erro ao alterar o status dos pedidos.');
            }
        } else {
            Alert('Por favor, selecione um novo status para o pedido.', false, true);
        }
    }

    render() {
        const { statusPedido, novoStatus, show, motivo, showMotivo } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title><FaEdit /> Editar Status do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!showMotivo && <Form>
                        <Form.Group controlId="formStatus">
                            <Form.Label>Novo Status do Pedido</Form.Label>
                            <Form.Control as="select" value={novoStatus} onChange={this.handleStatusChange}>
                                <option value="">Selecione...</option>
                                {statusPedido.map((status) => (
                                    <option key={status.status_pedido_id} value={status.status_pedido_id}>{status.nome}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form>}
                    {showMotivo && <Form>
                        <Form.Group controlId="formMotivo">
                            <Form.Label>Descreva o motivo</Form.Label>
                            <Form.Control as="textarea" value={motivo} onChange={e => this.setState({ ...this.state, motivo: e.target.value })} />
                            <small>{motivo.length}/150</small>
                        </Form.Group>
                    </Form>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.onHide}>Cancelar</Button>
                    <Button disabled={(novoStatus == '' || novoStatus == 5 && (!motivo || motivo.length < 10))} variant="primary" onClick={this.handleEditarStatus}>Salvar</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ModalEditarAllStatusPedido;